// @ts-nocheck
/* eslint-disable */

import { fetchFullstoryConfig } from './cookiePolicy.api';

const GA_ID = process.env.GATSBY_GA_ID;

export const linkedinTracker = () => {
  var _linkedin_partner_id = '497052';
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  (function() {
    var s = document.getElementsByTagName('script')[0];
    var b = document.createElement('script');
    b.type = 'text/javascript';
    b.async = true;
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    s.parentNode.insertBefore(b, s);
  })();
};

export const facebookTracker = () => {
  !(function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );
  fbq('init', '264134414269198');
  fbq('track', 'PageView');
};

export const fullstoryTracker = async () => {
  const _fullStoryConfig = await fetchFullstoryConfig();
  if (_fullStoryConfig) {
    window['_fs_debug'] = false;
    window['_fs_host'] = 'www.fullstory.com';
    window['_fs_org'] = '274VQ';
    window['_fs_namespace'] = 'FS';
    (function(m, n, e, t, l, o, g, y) {
      if (e in m && m.console && m.console.log) {
        m.console.log(
          'FullStory namespace conflict. Please set window["_fs_namespace"].',
        );
        return;
      }
      g = m[e] = function(a, b) {
        g.q ? g.q.push([a, b]) : g._api(a, b);
      };
      g.q = [];
      o = n.createElement(t);
      o.async = 1;
      o.src = 'https://' + _fs_host + '/s/fs.js';
      y = n.getElementsByTagName(t)[0];
      y.parentNode.insertBefore(o, y);
      g.identify = function(i, v) {
        g(l, { uid: i });
        if (v) g(l, v);
      };
      g.setUserVars = function(v) {
        g(l, v);
      };
      g.identifyAccount = function(i, v) {
        o = 'account';
        v = v || {};
        v.acctId = i;
        g(o, v);
      };
      g.clearUserCookie = function(c, d, i) {
        if (!c || document.cookie.match('fs_uid=[`;`]*`[`;`]*`[`;`]*`')) {
          d = n.domain;
          while (1) {
            n.cookie =
              'fs_uid=;domain=' +
              d +
              ';path=/;expires=' +
              new Date(0).toUTCString();
            i = d.indexOf('.');
            if (i < 0) break;
            d = d.slice(i + 1);
          }
        }
      };
    })(window, document, window['_fs_namespace'], 'script', 'user');
    if (_fullStoryConfig.id != null) {
      FS.identify(_fullStoryConfig.id, {
        displayName: '' + _fullStoryConfig.id,
        email: '' + _fullStoryConfig.id,
      });
    }
  }
};

export const twitterTracker = () => {
  !(function(e, t, n, s, u, a) {
    e.twq ||
      ((s = e.twq = function() {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
      }),
      (s.version = '1.1'),
      (s.queue = []),
      (u = t.createElement(n)),
      (u.async = !0),
      (u.src = '//static.ads-twitter.com/uwt.js'),
      (a = t.getElementsByTagName(n)[0]),
      a.parentNode.insertBefore(u, a));
  })(window, document, 'script');
  // Insert Twitter Pixel ID and Standard Event data below
  twq('init', 'o22yw');
  twq('track', 'PageView');
};

export const googleAnalytics = (isCookiesOptIn, isGaCookieAccepted) => {
  const allowAdFeatures = isCookiesOptIn && isGaCookieAccepted;
  // Global site tag (gtag.js) - Google Analytics
  const gaScript = document.createElement('script');
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.body.appendChild(gaScript);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', GA_ID, {
    allow_ad_personalization_signals: allowAdFeatures,
    anonymize_ip: true,
  });
};
